import Cookies from "js-cookie";
import {history} from '../routers/AppRouter';
import {instance, getCurrentCamp} from './api'

// Returns { jwt, user } on success, or the axios error (with .response.data.error) on failure.
export const apiLogin = async (email, password) => {
  try {
    const res = await instance.post('/auth/login', {
      identifier: email.toLowerCase(),
      password: password
    })
    await setToken(res.data)
    return res
  }
  catch (e) {
    console.log(e.message)
    return e
  }
};

export const setToken = async (token) => {
  const {user, bootcamp, team} = await getCurrentCamp(token.jwt);
  Cookies.set("bootcamp", bootcamp || "", { expires: 1 })
  Cookies.set("team", team || "", { expires: 1 });
  Cookies.set("username", user.username, { expires: 1 });
  Cookies.set("user", JSON.stringify(user), { expires: 1 })
  Cookies.set("jwt", token.jwt, { expires: 1 });

  if (Cookies.get("username")) {
    history.push(user.role === 'admin' && !bootcamp ? '/admin' : '/dashboard')
  }
};

// Re-reads the user's bootcamp and team so changes an admin made since login show up.
export const refreshSession = async () => {
  const {user, bootcamp, team} = await getCurrentCamp();
  Cookies.set("bootcamp", bootcamp || "", { expires: 1 })
  Cookies.set("team", team || "", { expires: 1 });
  Cookies.set("user", JSON.stringify(user), { expires: 1 })
  return { user, bootcamp, team };
};

// Admin "log in as": keep the admin's own token aside so they can switch back.
export const startImpersonating = async (userId) => {
  const res = await instance.post(`/admin/users/${userId}/impersonate`);
  Cookies.set("adminJwt", Cookies.get("jwt"), { expires: 1 });
  await setToken(res.data);
  history.push('/dashboard');
};

export const isImpersonating = () => !!Cookies.get("adminJwt");

export const stopImpersonating = async () => {
  const adminJwt = Cookies.get("adminJwt");
  Cookies.remove("adminJwt");
  if (!adminJwt) return unsetToken();
  await setToken({ jwt: adminJwt });
  history.push('/admin');
};

export const unsetToken = () => {
  Cookies.remove("adminJwt");
  Cookies.remove("jwt");
  Cookies.remove("username");
  Cookies.remove("user");
  Cookies.remove("team");
  Cookies.remove("bootcamp");

  // to support logging out from all windows
  window.localStorage.setItem("logout", Date.now());
  history.push('/')
};

export const getUserFromLocalCookie = () => {
  return Cookies.get("username");
};

export const getCurrentUser = () => {
  try {
    return JSON.parse(Cookies.get("user") || "null");
  } catch (e) {
    return null;
  }
};

class Auth {
  constructor() {
    this.authenticated = false
  }
  login(email, password) {
    this.authenticated = true
    return apiLogin(email, password)
  }
  logout() {
    this.authenticated = false
  }
  isAuthenticated() {
    this.authenticated = !!getUserFromLocalCookie();
    return this.authenticated
  }
}

export default new Auth();
